// 提示框

let tipPop = {
	Success(message) {
		window.ElementUI.Notification({
			title: '成功',
			message: message,
			type: 'success',
		});
	},
	warning(message) {
		window.ElementUI.Notification({
			title: '警告',
			message: message,
			type: 'warning',
		});
	},
	info(message) {
		window.ElementUI.Notification.info({
			title: '消息',
			message: message,
		});
	},
	error(code, msg) {
		let codeInfo = (code && `状态码${code},`) || '';
		window.ElementUI.Notification.error({
			title: '错误',
			message: `${codeInfo}${msg || '请联系管理员'}`,
			iconClass: 'icon-tishi iconfont',
			customClass: 'iconClass',
		});
	},
};
function checkAll(arr) {
	let word = JSON.parse(arr);
	let dataarr = [];
	word.forEach(item => {
		const parent = dataarr.find(c => c.sort === item.sort);
		if (parent) {
			parent.childs.push(item.sensitiveWord);
		} else {
			const obj = {
				sort: item.sort,
				childs: [item.sensitiveWord],
			};
			dataarr.push(obj);
		}
	});
	return dataarr;
}
export default {
	tipPop,
	checkAll,
};
